import RequestService, {
    RequestServiceResponse,
} from '@tcc-online/request-service';
import IReports from '../types/IReports';

const ENDPOINT = '/participant/output-reports';

const OutputReportService = {
    getReports,
};

async function getReports(): Promise<RequestServiceResponse<IReports[]>> {
    return await RequestService.get(ENDPOINT);
}

export default OutputReportService;
